<template>
  <div style=" width: 1200px; margin: 0 auto; background-color: #F2F6FC;">
    <Title :title="{name:'协同办公申请',path:'/item/coworking'}"></Title>

    <el-card class="box-card" style="min-height: 650px;margin-top: 15px;">
      <el-form ref="formdata" :model="formdata" :rules="rules" label-position="left" label-width="150px">
        <el-divider content-position="left">协同信息</el-divider>
        
        <el-form-item prop="user" label="协同部门">
<!--          <el-cascader-->
<!--            ref="cascader"-->
<!--            v-model="formdata.user"-->
<!--            :options="options"-->
<!--            :props="props"-->
<!--            clearable-->
<!--            collapse-tags-->
<!--            @visible-change="disableDept"-->
<!--            @blur="validUser"-->
<!--            @change="disableDept">-->
<!--          </el-cascader>-->
          <el-select
              v-model="formdata.user"
              filterable
              clearable
              collapse-tags
              @change="selectDept"
          >
            <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                :disabled="item.disabled"
            >
            </el-option>
          </el-select>
        </el-form-item>
        
        <el-form-item prop="workTimes" label-width="150px" label="协同时间">
          <el-date-picker
            v-model="formdata.workTimes"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
          ></el-date-picker>
        </el-form-item>
        
        <el-form-item prop="coworkingSubject" label-width="150px" label="协同事由">
          <el-input type="textarea" rows=5 maxlength="300"
            show-word-limit v-model="formdata.coworkingSubject">
          </el-input>
        </el-form-item>
        
        <el-form-item>
          <el-button v-if="submitShow" type="primary" @click="submit">提交申请</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import Title from "../../Title";
import { AesDecrypt } from "@/util";
import { watch } from "vue";
import {requestUserGet, requestCoworkingApply, requestApplyDetail} from "@/api";
export default {
  name: "CoworkingApply",
  components: {Title},
  data() {
    return {
      submitShow: true,
      deptId: "",
      options: [],
      props: {
        multiple: true,
        expandTrigger: 'hover'
      },
      formdata: {
        user: null,
        workTimes: null,
        coworkingSubject: "",
      },
      rules: {
        user: [
          {required: true, message: '请选择协同部门', trigger: 'blur'}
        ],
        workTimes: [
          {required: true, message: '请选协同择时间', trigger: 'blur'}
        ],
        coworkingSubject: [
          {required: true, message: '请填写协同事由', trigger: 'blur'}
        ]
      }
    }
  },
  created() {
    const user = JSON.parse(AesDecrypt(window.localStorage.getItem("user")))
    this.deptId = user.deptId
    this.loadUserList()
    this.applyId = this.$route.query.applyId
    this.applyServiceId = this.$route.query.applyServiceId
    this.applyType = this.$route.query.applyType
    if (this.applyId || this.applyServiceId || this.applyType) {
      this.reapply = true
      this.getDetail()
    }
  },
  methods: {
    selectDept(value){
      console.log("选择的部门",value,"当前的部门id",this.deptId)
      this.formdata.user = value
    },

    // validUser() {
    //   // 不知什么原因失去焦点不触发验证  手动触发验证
    //   this.$refs['validUser'].validate('blur')
    // },
    // disableDept() {
    //   this.validUser()
    //   console.log(this.deptId)
    //   for (let i = 0; i < this.options.length; i++) {
    //     if (this.options[i].value === this.deptId) {
    //       this.options[i].disabled = true;
    //     }
    //   }
    //   // 只能选择同部门的人
    //   const nodes = this.$refs['cascader'].getCheckedNodes()
    //   let len = nodes.length
    //   if (len === 0) {
    //     // 恢复状态
    //     for (let i = 0; i < this.options.length; i++) {
    //       if (this.options[i].value !== this.deptId) {
    //         this.options[i].disabled = false;
    //       }
    //     }
    //     return
    //   }
    //   const parentNode = nodes[len-1].parent
    //   let deptId = parentNode.value
    //   for (let i = 0; i < this.options.length; i++) {
    //     let option = this.options[i]
    //     if (option.value !== deptId) {
    //       option.disabled = true;
    //     }
    //   }
    // },
    submit() {
      this.$refs['formdata'].validate((isPass) => {
        if (isPass) {
          this.submitShow = false
          let people = {}
          console.log('选择的部门',this.formdata.user)
          people.deptId = this.formdata.user;
          console.log('协同人员参数',people)
          // for (let i = 0; i < this.formdata.user.length; i++) {
          //   const u = {
          //     deptId: this.formdata.user[i][0],
          //     userId: this.formdata.user[i][1]
          //   }
          //   people.push(u)
          // }
          const param = {
            startTime: this.formdata.workTimes[0],
            endTime: this.formdata.workTimes[1],
            coworkingSubject: this.formdata.coworkingSubject,
            people: people
          }
          if (this.reapply) {
            param.coworkingId = this.coworkingId
            param.reapply = this.reapply
            param.applyId = this.applyId
          }
          requestCoworkingApply(param).then(res => {
            this.submitShow = true
            if (res.code === 200) {
              this.$message.success(res.msg)
              this.$refs['formdata'].resetFields()
              if (this.reapply) {
                this.$router.push({query: {}})
              }
            }
          }).catch(err => {
            this.submitShow = true
          })
        }
      })
    },
    async loadUserList() {
      let res = await requestUserGet();
      if (res.code === 200) {
        let users = res.object;
        let depts = new Map()
        for (let i = 0; i < users.length; i++) {
          let hasDept = depts.has(users[i].deptId)
          const node = {
            value: users[i].userId,
            label: users[i].realName,
          }
          if (hasDept) {
            let nodes = depts.get(users[i].deptId)
            nodes.push(node)
          } else {
            const n = {
              value: users[i].deptId,
              label: users[i].deptName,
              disabled: users[i].deptId === this.deptId,
              children: []
            }
            this.options.push(n)
            let nodes = []
            nodes.push(node)
            depts.set(users[i].deptId, nodes)
          }
        }
        for (let i = 0; i < this.options.length; i++) {
          this.options[i].children = depts.get(this.options[i].value)
        }
      } else {
        this.$message.error("获取人员列表失败")
      }
    },
    async getDetail() {
      const param = {
        applyId: this.applyId,
        applyServiceId: this.applyServiceId,
        applyType: this.applyType
      }
      // 获取重新申请的详情数据
      const res = await requestApplyDetail(param)
      if (res.code === 200) {
        let detail = res.object.detail
        this.coworkingId = detail.coworkingId
        let time = []
        time[0] = detail.startTime
        time[1] = detail.endTime
        this.formdata.workTimes = time
        this.formdata.coworkingSubject = detail.coworkingSubject
        // console.log("重新申请的部门信息",detail.people[0].deptId)
        // let user = []
        // for (let i = 0; i < detail.people.length; i++) {
        //   let n = []
        //   n[0] = detail.people[i].deptId
        //   n[1] = detail.people[i].userId
        //   user.push(n)
        // }
        // console.log("重新申请的user",user)
        this.formdata.user = detail.people[0].deptId
      }
    }
  }
}
</script>

<style>

</style>